"use client"

import VibrantMenuHero from "./components/MenuHero"
import VibrantFooter from "./components/Footer"
import CategoriesSection from "@/components/categories-section"
import BeveragesSection from "@/components/beverages-section"
import OrderStatusModal from "@/components/order-status-modal"
import OrderCompletionModal from "@/components/order-completion-modal"
import ConnectionStatus from "@/components/connection-status"
import NotificationContainer from "@/components/notification-container"
import FloatingNav from "@/components/floating-nav"
import BuffetAd from "@/components/buffet-ad"
import { useApp } from "@/lib/context"

interface MenuTemplateProps {
  isLoading?: boolean
  onLoadingComplete?: () => void
}

export default function VibrantMenu({ isLoading = false, onLoadingComplete }: MenuTemplateProps) {
  const { categoriesBebidas } = useApp()

  return (
    <main className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50">
      {/* Vibrant Theme: Colorful, playful, rounded */}

      <VibrantMenuHero />

      <BuffetAd />

      <div className="px-4">
        <CategoriesSection variant="vibrant" />
      </div>

      {categoriesBebidas.length > 0 && (
        <div className="mt-12">
          <BeveragesSection />
        </div>
      )}

      <VibrantFooter />

      {/* Modais e overlays partilhados */}
      <OrderStatusModal />
      <OrderCompletionModal />
      <NotificationContainer />
      <ConnectionStatus />
      <FloatingNav />
    </main>
  )
}
